import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MydiaryService } from 'src/app/services/mydiary.service';
import { MasterDataService } from '../../services/master-data.service';
import { ApproverModel, TravelSheetModel, clientModel, FYModel, UserModel, FareDocumentModel } from './travel-sheet.model';
import { TravelSheetService } from '../../services/travel-sheet.service';
import * as moment from 'moment';
import { CommonMessageService } from '../../services/common-message.service';
import { HumanResourceService } from '../../services/human-resource.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-travel-sheet',
  templateUrl: './travel-sheet.component.html',
  styleUrls: ['./travel-sheet.component.css']
})
export class TravelSheetComponent implements OnInit {
  travelSheetModel: TravelSheetModel;
  approverModel: ApproverModel;
  clientModel: clientModel;
  financialYearModel: FYModel;
  userModel: UserModel;
  chargeableToClient;
  userId;
  travelSheetList: Array<TravelSheetModel>;
  hideSaveButton = false;
  userRole;
  hideButtons = false;
  currentDate;
  partnerList;
  branchId;
  branchName;
  clientHasPGB=false;
  selectedFY = null;
  approverListForSelfApprove;
  constructor(private modalService: NgbModal,
    private mydiaryService: MydiaryService,
    private masterDataService: MasterDataService,
    private travelSheetService: TravelSheetService,
    private commonMessageService: CommonMessageService,
    private humanResourceService: HumanResourceService,) {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit(): void {
    this.branchId=localStorage.getItem('branchId');
    this.branchName=localStorage.getItem('branchName');
    // this.getPartnerList();

    this.travelSheetModel = new TravelSheetModel();
    this.approverModel = new ApproverModel();
    this.clientModel = new clientModel();
    this.financialYearModel = new FYModel();
    this.userModel = new UserModel();

    this.travelSheetModel.approver = null;
    this.travelSheetModel.client = null;
    this.travelSheetModel.fy = null;
    this.travelSheetModel.advanceApprover = null;
    this.travelSheetModel.assignment = null;
    // this.travelSheetModel.chargeble=null;

    this.userId = localStorage.getItem('id');

    this.userModel.id = this.userId;
    console.log('userID', this.userId);
    this.travelSheetModel.user = this.userModel;
    this.userRole = localStorage.getItem('userRole');
    // if(this.userRole=='Account Executive'){
    //   this.getAllSubmittedTravelSheetList();
    //   this.hideButtons=true;
    // }
    // else{
    // this.getAllTravelSheetList();
    // }

    this.loadApprovalList();
    this.loadClientList();
    this.loadFinancialYearList();
    //this.getAllTravelSheetList();
  }

  

  getPartnerList(){
    console.log('inside partner list')
    this.masterDataService.getUserPartnersOfBranch(this.branchId).subscribe((resp:any)=>{
      console.log('partner list',resp);
      this.partnerList=resp;
      const partnerIndex = this.partnerList.findIndex((item) => item.id == this.userId);
       console.log('partnerIndex',this.partnerList[partnerIndex]);
       this.travelSheetModel.approver=this.partnerList[partnerIndex];
      }) 
  }



  approverName = false;
  getAllTravelSheetList() {
    if (this.userRole == 'Partner') {
      this.approverName = true;
    } else {
      this.approverName = false;
    }
    this.travelSheetService.getTravelSheetDetails(this.userId,this.selectedFY.id).subscribe((resp: any) => {
      console.log('travel sheet', resp);
      this.travelSheetList = resp;

      for (let i = 0; i < this.travelSheetList.length; i++) {
        var entryDate = new Date(this.travelSheetList[i].entryDate);
        this.selectedEntryDate = { year: entryDate.getFullYear(), month: entryDate.getMonth() + 1, day: entryDate.getDate() };
        // this.travelSheetModel.entryDate=this.selectedEntryDate;
        this.travelSheetList[i].entryDate = this.selectedEntryDate;

        var fromDate = new Date(this.travelSheetList[i].fromDate);
        this.selectedFromDate = { year: fromDate.getFullYear(), month: fromDate.getMonth() + 1, day: fromDate.getDate() };
        this.travelSheetList[i].fromDate = this.selectedFromDate;

        var toDate = new Date(this.travelSheetList[i].toDate);
        this.selectedToDate = { year: toDate.getFullYear(), month: toDate.getMonth() + 1, day: toDate.getDate() };
        this.travelSheetList[i].toDate = this.selectedToDate;
      }
    });
  }

  getAllSubmittedTravelSheetList() {
    this.travelSheetService.getAllSubmittedTravelSheetDetails().subscribe((resp: any) => {
      console.log('submitted travel sheet', resp);
      this.travelSheetList = resp;
      for (let i = 0; i < this.travelSheetList.length; i++) {
        var entryDate = new Date(this.travelSheetList[i].entryDate);
        this.selectedEntryDate = { year: entryDate.getFullYear(), month: entryDate.getMonth() + 1, day: entryDate.getDate() };
        // this.travelSheetModel.entryDate=this.selectedEntryDate;
        this.travelSheetList[i].entryDate = this.selectedEntryDate;

        var fromDate = new Date(this.travelSheetList[i].fromDate);
        this.selectedFromDate = { year: fromDate.getFullYear(), month: fromDate.getMonth() + 1, day: fromDate.getDate() };
        this.travelSheetList[i].fromDate = this.selectedFromDate;

        var toDate = new Date(this.travelSheetList[i].toDate);
        this.selectedToDate = { year: toDate.getFullYear(), month: toDate.getMonth() + 1, day: toDate.getDate() };
        this.travelSheetList[i].toDate = this.selectedToDate;
      }
    });
  }

  afterClientSelect() {
    console.log('this.travelSheetModel.chargeble', this.travelSheetModel.client.chargeableToClient);
    this.travelSheetModel.chargeble = this.travelSheetModel.client.chargeableToClient;
    console.log('selected client:',this.travelSheetModel.client);
    if(this.hasPGB())
    {  console.log('yes');
       this.clientHasPGB=true;
      
    }
    else{
      console.log('no');
      this.clientHasPGB=false;
    }
    this.loadClientAssignment(this.travelSheetModel.client);

  }

   hasPGB(): boolean {
    return this.travelSheetModel.client.name.includes("PGB");
  }

  assignmentList;
  loadClientAssignment(client) {
    console.log('client value', client);
    this.mydiaryService.getClientBudgetedAssignments(client.id)
      .subscribe(res => {
        console.log('assignmnet', res);
        this.assignmentList = res;
      });
  }

  selectedEntryDate;
  onEntryDateSelect() {
    var selectedEntryDate2 = moment({
      year: this.selectedEntryDate.year,
      month: this.selectedEntryDate.month - 1, // Months are 0-based in moment.js
      day: this.selectedEntryDate.day
    }).format("YYYY-MM-DD");
  
    this.travelSheetModel.entryDate = selectedEntryDate2;
    console.log('entry date', selectedEntryDate2);
  
    // leave date check
    // this.travelSheetService.checkSelectedDateLeave(selectedEntryDate2).subscribe((resp: any) => {
    //   console.log('leave response', resp);
    //   if (resp == true) {
    //     this.commonMessageService.okMessage("Can not fill travel sheet on Leave.");
    //     this.selectedEntryDate = null;
    //   }
    // });
  }
  
  

  selectedFromDate;
  onFromDateSelect() {
    var selectedFromDate2 = moment({
      year: this.selectedFromDate.year,
      month: this.selectedFromDate.month - 1, // Months are 0-based in moment.js
      day: this.selectedFromDate.day
    }).format("YYYY-MM-DD");
  
    this.travelSheetModel.fromDate = selectedFromDate2;
    console.log('From Date:', selectedFromDate2);
  }
  
  

  selectedToDate;
  onToDateSelect() {
    var selectedToDate2 = moment({
      year: this.selectedToDate.year,
      month: this.selectedToDate.month - 1, // Months are 0-based in JavaScript
      day: this.selectedToDate.day
    }).format("YYYY-MM-DD");
  
    this.travelSheetModel.toDate = selectedToDate2;
    console.log('To Date:', selectedToDate2);
  }
  
  

  noOfPersonValue() {
    if (this.travelSheetModel.noOfPersons == 0) {
      this.commonMessageService.swalAlertWithoutIcon('','No.Of Travelling Person Not Enter zero')
      this.travelSheetModel.noOfPersons = undefined;
    }
  }

  tollValue() {
    if (this.travelSheetModel.toll > 2500) {
      this.commonMessageService.swalAlertWithoutIcon('','Toll should not exceed Rs 2500')
      this.travelSheetModel.toll = undefined;
      this.travelSheetModel.totalAmount = undefined;
      this.travelSheetModel.netPayable = undefined;
    }
  }

  approverList;
  loadApprovalList() {
    this.humanResourceService.getLookupForManageProfile()
      .subscribe((res: any) => { 
        console.log('res.....', res);
        console.log('userId......', this.userId, this.userRole);
        console.log('branch',this.branchName);
        this.approverList = res.partners;
        this.approverListForSelfApprove=res.partners;
        if (['Partner', 'Managing Partner', 'Designated Partner'].includes(this.userRole)) {
          if(this.clientHasPGB==true){
          //   this.travelSheetModel.approver={
          //     "id": 1099,
          //     "userId": "sX37xsTHKRoa0kfrpCBcafv8j4cF9t",
          //     "firstName": "Ruchi",
          //     "middleName": "",
          //     "lastName": "Dwivedi",
          //     "email": "ruchi.dwivedi@giantleapsystems.com"
          // }
            this.travelSheetModel.approver={
                  "id": 52,
                  "userId": "ySDL5jgXFnw10QqfDM7AZVnevbirWF",
                  "firstName": "Abhijeet",
                  "middleName": "Dilip",
                  "lastName": "Bhagwat",
                  "email": "abhijeet_bhagwat@pgbhagwatca.com"
              }
              this.approverList = [];
        //   if(this.userId==1099){
        //   //   this.travelSheetModel.approver={
        //   //     "id": 52,
        //   //     "userId": "ySDL5jgXFnw10QqfDM7AZVnevbirWF",
        //   //     "firstName": "Abhijeet",
        //   //     "middleName": "Dilip",
        //   //     "lastName": "Bhagwat",
        //   //     "email": "abhijeet_bhagwat@pgbhagwatca.com"
        //   // }
          // this.travelSheetModel.approver={
          //   "id": 1099,
          //   "userId": "sX37xsTHKRoa0kfrpCBcafv8j4cF9t",
          //   "firstName": "Ruchi",
          //   "middleName": "",
          //   "lastName": "Dwivedi",
          //   "email": "ruchi.dwivedi@giantleapsystems.com"
          // }
          //   this.approverList = [];
        // }
        // else{
        // //   this.travelSheetModel.approver={
        // //     "id": 52,
        // //     "userId": "ySDL5jgXFnw10QqfDM7AZVnevbirWF",
        // //     "firstName": "Abhijeet",
        // //     "middleName": "Dilip",
        // //     "lastName": "Bhagwat",
        // //     "email": "abhijeet_bhagwat@pgbhagwatca.com"
        // // }
        // this.travelSheetModel.approver={
        //   "id": 1099,
        //   "userId": "sX37xsTHKRoa0kfrpCBcafv8j4cF9t",
        //   "firstName": "Ruchi",
        //   "middleName": "",
        //   "lastName": "Dwivedi",
        //   "email": "ruchi.dwivedi@giantleapsystems.com"
        //   }
        //   this.approverList = [];
        // }
        }else{
          for (let i = 0; i < this.approverList.length; i++) {
            if (this.approverList[i].id == this.userId) {
              this.travelSheetModel.approver = this.approverList[i];
              console.log('approver name', this.travelSheetModel.approver);
              this.approverList = [];
            }
          }
        }
        } else {
          this.approverList = res.partners;
        }
      });
  }

  clientList;
  loadClientList() {
    this.mydiaryService.getDiaryClients()
      .subscribe((res: any) => {
        console.log('client list', res);
        this.clientList = res;
      });
  }

  financialYearList;
  loadFinancialYearList() {
    // this.masterDataService.getFinancialYear()
    //   .subscribe(res => {
    //     console.log(" financal years :", res);
    //     this.financialYearList = res;
    //   });


      this.masterDataService.getFinancialYear()
        .subscribe(res => {
          console.log("years :", res);
          this.financialYearList = res;
          var fyIndex = -1;
          this.financialYearList.forEach((element, key) => {
            var startDate = new Date(element.startDate);
            var endDate = new Date(element.endDate);
            // var currentDate = new Date();
            var currentDate = moment(new Date()).format("YYYY-MM-DD");
            console.log(startDate, endDate);;
            console.log(currentDate + " " + element.startDate + " " + element.endDate);
            // if(currentDate>=startDate && currentDate<=endDate){
            //   fyIndex = key;
            // }
            if (currentDate >= element.startDate && currentDate <= element.endDate) {
              fyIndex = key;
            }
            console.log("fyIndex", fyIndex)
          });
          console.log("financialYearList[fyIndex]", this.financialYearList[fyIndex])
          this.selectedFY = this.financialYearList[fyIndex];
          console.log("this.selectedFY", this.selectedFY)
          this.getAllTravelSheetList();
        });
  
    
  }


  openModalClick(modalContent) {
    console.log(this.clientHasPGB);
    this.clientHasPGB=false;
    this.selectedEntryDate = null;
    this.selectedFromDate = null;
    this.selectedToDate = null;
    this.openModal(modalContent);
  }

  openModal(documentModalContent) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(documentModalContent, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  fareDocumentsList;
  openDocumentModal(content, fareDocuments) {
    this.fareDocumentsList = fareDocuments;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  onDeleteClick(travelSheet) {
    Swal.fire({
      text: 'Are you sure you want to Delete?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.travelSheetService.deleteTravelSheet(travelSheet.id).subscribe((resp: any) => {
              this.closeModal();
              this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','')
            });
      }
    })
   }

  changeMonthNumberToName(month) {
    return moment(month, 'M').format('MMMM');
  }

  buttonChangeStatus = false;
   onEditClick(travelSheet, modalContent)  {
     this.humanResourceService.getLookupForManageProfile()
    .subscribe((res: any) => { 
      console.log('res.....', res);
      console.log('userId......', this.userId, this.userRole);
      this.approverList = res.partners;
      this.myFiles = [];
      this.docType = [];
      this.loadClientAssignmentForEdit(travelSheet, modalContent);
    })
    console.log('travelsheet edi time', travelSheet);

  }

  loadClientAssignmentForEdit(travelSheet, modalContent) {
    this.mydiaryService.getClientBudgetedAssignments(travelSheet.client.id)
      .subscribe(res => {
        this.assignmentList = res;
        this.setTravelSheetDetailsForEdit(travelSheet, modalContent);
      });
  }

  setTravelSheetDetailsForEdit(travelSheet, modalContent) {
    this.showTrainFileChoose = true;
    this.showAirFileChoose = true;
    this.showTaxiFileChoose = true;
    this.showHotelFileChoose = true;
    this.showTollFileChoose = true;
    this.showFoodFileChoose = true;
    this.showOthersFileChoose = true;
    this.showMobileFileChoose = true;
    this.showInternetFileChoose = true;
    this.showICAIMembFileChoose = true;
    this.showMicrosoftSubFileChoose = true;
    this.showSeminarFeeFileChoose = true;

    console.log('assignmnetlist', this.assignmentList);
    if (travelSheet.sheetStatus == 'Resent') {
      this.buttonChangeStatus = true;
    }
    this.travelSheetModel = { ...travelSheet };
    console.log('travelSheet.advanceApprover.id', this.approverList);

    const approverIndex = this.approverList.findIndex((item) => item.id == travelSheet.approver.id);
    const clientIndex = this.clientList.findIndex((item) => item.id == travelSheet.client.id);
    const assignmentIndex = this.assignmentList.findIndex((item) => item.id == travelSheet.assignment.id);
    const fyIndex = this.financialYearList.findIndex((item) => item.id == travelSheet.fy.id);

    this.travelSheetModel.approver = this.approverList[approverIndex];
    this.travelSheetModel.client = this.clientList[clientIndex];
    this.travelSheetModel.assignment = this.assignmentList[assignmentIndex];
    this.travelSheetModel.fy = this.financialYearList[fyIndex];
    console.log('travelSheet.advanceApprover.id', this.travelSheetModel.approver);
    if (travelSheet.advanceApprover != null) {
      const advancedApproverIndex = this.approverList.findIndex((item) => item.id == travelSheet.advanceApprover.id);
      this.travelSheetModel.advanceApprover = this.approverList[advancedApproverIndex];
    }
    this.hideSaveButton = true;
    this.openModal(modalContent);
  }

  closeModal() {
    this.getAllTravelSheetList();
    this.loadApprovalList();
    this.modalService.dismissAll();
    this.travelSheetModel = new TravelSheetModel();
    this.selectedEntryDate = null;
    this.selectedFromDate = null;
    this.selectedToDate = null;
    this.travelSheetModel.approver = null;
    this.travelSheetModel.client = null;
    this.travelSheetModel.fy = null;
    this.travelSheetModel.advanceApprover = null;
    this.travelSheetModel.assignment = null;
    this.hideSaveButton = false;
    this.buttonChangeStatus = false;
    this.showLableUpload = false;
    this.docType = [];
    this.myFiles = [];
  }

  myFiles = [];
  docType = [];
  fileChange(event, documentType) {
    console.log('document type', event);
    for (var i = 0; i < event.target.files.length; i++) {
      this.myFiles.push(event.target.files[i]);
      this.docType.push(documentType);
    }
    console.log('this.myFiles', this.myFiles);
    console.log('this.docType', this.docType);
  }

  validateDocumentType(docType, doc) {
    var statusFound: boolean;
    for (let i = 0; i < docType.length; i++) {
      if (docType[i] == doc) {
        statusFound = true;
      }
    }
    return statusFound;
  }

  validateDocumentTypeCheck(docType, doc) {
    console.log('doctypevalues', docType);
    var statusFound: boolean;
    for (let i = 0; i < docType.length; i++) {
      if (docType[i].type == doc) {
        statusFound = true;
      }
    }
    return statusFound;
  }

  onSaveClick() {

    if (['Partner', 'Managing Partner', 'Designated Partner'].includes(this.userRole) && this.clientHasPGB==true){
       
      this.travelSheetModel.approver={
        "id": 52,
        "userId": "ySDL5jgXFnw10QqfDM7AZVnevbirWF",
        "firstName": "Abhijeet",
        "middleName": "Dilip",
        "lastName": "Bhagwat",
        "email": "abhijeet_bhagwat@pgbhagwatca.com"
    }
    
    }
    else{
      for (let i = 0; i < this.approverListForSelfApprove.length; i++) {
        if (this.approverListForSelfApprove[i].id == this.userId) {
          this.travelSheetModel.approver = this.approverListForSelfApprove[i];
          console.log('approver name', this.travelSheetModel.approver);
          this.approverListForSelfApprove = [];
        }
      }
    }

    console.log('Approver name....',this.travelSheetModel.approver)
    if (this.travelSheetModel.approver != null && this.travelSheetModel.client != null && this.travelSheetModel.assignment != null &&
      this.travelSheetModel.fy != null && this.travelSheetModel.entryDate != undefined &&
      this.travelSheetModel.fromDate != undefined && this.travelSheetModel.toDate != undefined && this.travelSheetModel.noOfPersons != undefined) {
      if (this.travelSheetModel.trainAmount != undefined || this.travelSheetModel.airAmount != undefined || this.travelSheetModel.taxiAmount != undefined ||
        this.travelSheetModel.hotelAmount != undefined || this.travelSheetModel.toll != undefined || this.travelSheetModel.foodAmount != undefined
        || this.travelSheetModel.otherAmount != undefined || this.travelSheetModel.carAmount != undefined ||
        this.travelSheetModel.internetAmount != undefined || this.travelSheetModel.mobileAmount != undefined ||
        this.travelSheetModel.icaiMembershipFee != undefined || this.travelSheetModel.microsoft365Subscription != undefined ||
        this.travelSheetModel.seminarFee != undefined) {
        console.log('doctype value', this.docType.length, 'this.travelSheetModel.carAmount', this.travelSheetModel.carAmount);
        if (this.docType.length > 0 || this.travelSheetModel.carAmount != undefined || this.travelSheetModel.toll) {
          var validDocumentTypeValue: boolean;
          if (this.travelSheetModel.trainAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "train");
            console.log('train validDocument', validDocument);
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Train Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.airAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "air");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Air Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.taxiAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "taxi");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Taxi Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.hotelAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "hotelStay");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Hotel Document');
              validDocumentTypeValue = true;
            }
          }
          // if (this.travelSheetModel.toll != undefined) {
          //   var validDocument = this.validateDocumentType(this.docType, "toll");
          //   if (!validDocument) {
          //     this.commonMessageService.okMessage('Need to add Toll Document');
          //     validDocumentTypeValue = true;
          //   }
          // }
          if (this.travelSheetModel.foodAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "foodExpense");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Food Expense Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.mobileAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "mobile");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add mobile Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.internetAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "internet");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add internet Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.icaiMembershipFee != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "icaiMembershipFee");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add ICAI membership fee Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.microsoft365Subscription != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "microsoft365Subscription");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add microsoft 365 subscription Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.seminarFee != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "seminarFee");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add seminar fee Document');
              validDocumentTypeValue = true;
            }
          }

          if (this.travelSheetModel.otherAmount != undefined) {
            var validDocument = this.validateDocumentType(this.docType, "others");
            if (!validDocument) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Others Document')
              validDocumentTypeValue = true;
            } else {
              if (this.travelSheetModel.otherAmount != undefined && this.travelSheetModel.natureOfExpense == undefined) {
                this.commonMessageService.swalAlertWithoutIcon('','Need to add Nature of Expense')
                validDocumentTypeValue = true;
              } else if (this.travelSheetModel.otherAmount > 10000) {
                this.commonMessageService.swalAlertWithoutIcon('','Other Amount should not be greater than 10000.')
                validDocumentTypeValue = true;
              }
            }
          }
          if (!validDocumentTypeValue) {
            this.travelSheetModel.user = this.userModel;
            console.log('>>>>',this.travelSheetModel.user)
            const data = new Blob([JSON.stringify(this.travelSheetModel)], {
              type: 'application/json'
            });
            console.log('inside else');
            const formData = new FormData();
            for (var i = 0; i < this.myFiles.length; i++) {
              formData.append('files', this.myFiles[i]);
            }
            formData.append('travelSheetRequestModel', data);

            console.log('Travelsheet model values', JSON.stringify(this.travelSheetModel));
            this.travelSheetService.saveTravelSheetDetails(formData, this.docType).subscribe((resp: any) => {
              console.log('save resp', resp);
              this.closeModal();
              this.commonMessageService.saveMessage();
            });
          }
        } else {
          this.commonMessageService.swalAlertWithoutIcon('','Attach Document');
        }
      } else {
        this.commonMessageService.swalAlertWithoutIcon('','Atleast Enter One Travelling Amount');
      }
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Fill All Mandatory Fields....!');
    }
  }

  checkBudgetAfterFyClick() {
    this.masterDataService.getBudgetExistForAssignent(this.travelSheetModel.client.id, this.travelSheetModel.fy.id, this.travelSheetModel.assignment.id).subscribe((resp: any) => {
      console.log('response details', resp);
      if (resp == false) {
        // this.commonMessageService.swalAlertWithoutIcon('','Budget does not exist for this ' + this.travelSheetModel.client.name + ' client, for this ' + this.travelSheetModel.assignment.name + ' assignment & for this Financial Year ' + this.travelSheetModel.fy.name);
        this.commonMessageService.swalAlertWithoutIcon('','Budget does not exist for this ' + this.travelSheetModel.client.name + ' client, for this ' + this.travelSheetModel.assignment.name + ' assignment & for this Financial Year ' + this.travelSheetModel.fy.name)
        this.travelSheetModel.fy = null;
      }
    });
  }

  showTrainFileChoose: boolean;
  showAirFileChoose: boolean;
  showTaxiFileChoose: boolean;
  showTollFileChoose: boolean;
  showHotelFileChoose: boolean;
  showFoodFileChoose: boolean;
  showMobileFileChoose: boolean;
  showInternetFileChoose: boolean;
  showICAIMembFileChoose: boolean;
  showMicrosoftSubFileChoose: boolean;
  showSeminarFeeFileChoose: boolean;
  showOthersFileChoose: boolean;
  showLableUpload: boolean;
  calculateAllTotal() {
    if (this.travelSheetModel.carAmount != undefined) {
      this.showLableUpload = false;
    } else {
      this.showLableUpload = true;
    }
    this.travelSheetModel.totalAmount = 0;
    if (this.travelSheetModel.trainAmount != undefined) {
      // this.travelSheetModel.totalAmount += this.travelSheetModel.trainAmount;
      this.travelSheetModel.totalAmount += (this.travelSheetModel.trainAmount || 0) + (this.travelSheetModel.trainGstAmount || 0);
      this.showTrainFileChoose = true;
    } else {
      this.showTrainFileChoose = false;
    }
    if (this.travelSheetModel.airAmount != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.airAmount || 0) + (this.travelSheetModel.airGstAmount || 0);
      this.showAirFileChoose = true;
    } else {
      this.showAirFileChoose = false;
    }
    if (this.travelSheetModel.taxiAmount != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.taxiAmount || 0) + (this.travelSheetModel.taxiGstAmount || 0);
      this.showTaxiFileChoose = true;
    } else {
      this.showTaxiFileChoose = false;
    }
    if (this.travelSheetModel.carAmount != undefined) {
      this.travelSheetModel.totalAmount += this.travelSheetModel.carAmount;
    }
    if (this.travelSheetModel.hotelAmount != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.hotelAmount || 0) + (this.travelSheetModel.hotelGstAmount || 0);
      this.showHotelFileChoose = true;
    } else {
      this.showHotelFileChoose = false;
    }
    if (this.travelSheetModel.toll != undefined) {
      this.travelSheetModel.totalAmount += this.travelSheetModel.toll;
      this.showTollFileChoose = true;
    } else {
      this.showTollFileChoose = false;
    }
    if (this.travelSheetModel.foodAmount != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.foodAmount || 0) + (this.travelSheetModel.foodGstAmount || 0);
      this.showFoodFileChoose = true;
    } else {
      this.showFoodFileChoose = false;
    }
    if (this.travelSheetModel.mobileAmount != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.mobileAmount || 0) + (this.travelSheetModel.mobileGstAmount || 0);
      this.showMobileFileChoose = true;
    } else {
      this.showMobileFileChoose = false;
    }
    if (this.travelSheetModel.internetAmount != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.internetAmount || 0) + (this.travelSheetModel.internetGstAmount || 0);
      this.showInternetFileChoose = true;
    } else {
      this.showInternetFileChoose = false;
    }
    if (this.travelSheetModel.icaiMembershipFee != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.icaiMembershipFee || 0) + (this.travelSheetModel.icaiMembershipGstAmount || 0);
      this.showICAIMembFileChoose = true;
    } else {
      this.showICAIMembFileChoose = false;
    }
    if (this.travelSheetModel.microsoft365Subscription != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.microsoft365Subscription || 0) + (this.travelSheetModel.microsoft365SubscriptionGstAmount || 0);
      this.showMicrosoftSubFileChoose = true;
    } else {
      this.showMicrosoftSubFileChoose = false;
    }
    if (this.travelSheetModel.seminarFee != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.seminarFee || 0) + (this.travelSheetModel.seminarFeeGstAmount || 0);
      this.showSeminarFeeFileChoose = true;
    } else {
      this.showSeminarFeeFileChoose = false;
    }
    if (this.travelSheetModel.otherAmount != undefined) {
      this.travelSheetModel.totalAmount += (this.travelSheetModel.otherAmount || 0) + (this.travelSheetModel.otherGstAmount || 0);
      this.showOthersFileChoose = true;
    } else {
      this.showOthersFileChoose = false;
    }
    this.netPayableTotalAmount();
  }

  netPayableTotal;
  netPayableTotalAmount() {
    this.netPayableTotal = 0;
    if (this.travelSheetModel.advanceTaken != undefined) {
      this.netPayableTotal = (this.travelSheetModel.totalAmount - this.travelSheetModel.advanceTaken);
      this.travelSheetModel.netPayable = this.netPayableTotal;
    } else {
      this.travelSheetModel.netPayable = this.travelSheetModel.totalAmount;
    }
    console.log('travelsheet all total', this.netPayableTotal);
  }

  deleteDocument(document, index) {
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.travelSheetService.deleteTravelSheetDocument(document.id).subscribe((resp: any) => {
          this.commonMessageService.deleteMessage();
          this.travelSheetModel.fareDocuments.splice(index, 1);
        });
      }
    })
  }

  calculateCarAmount(refCarAmount) {
    console.log('refCar', refCarAmount);
    this.loadConveyance(refCarAmount);
  }

  conveyanceRate;
  loadConveyance(refCarAmount) {
    this.mydiaryService.getConveyanceRate()
      .subscribe((res: any) => {
        console.log("conyencance Rate", res);
        this.conveyanceRate = res;
        console.log('chargable to client', this.travelSheetModel.chargeble);
        console.log('this.conveyanceRate.fourWheelerRate', this.conveyanceRate.fourWheelerRate, refCarAmount);
        if (this.travelSheetModel.chargeble == true) {
          this.travelSheetModel.carAmount = (this.conveyanceRate.fourWheelerRate * refCarAmount);
          this.calculateAllTotal();
        } else {
          this.travelSheetModel.carAmount = (this.conveyanceRate.fourWheelerNonChargableRate * refCarAmount)
          this.calculateAllTotal();
        }
        console.log('car amount', this.travelSheetModel.carAmount);
      });
  }

  onUpdateClick() {
    // console.log('update click',this.travelSheetModel)
    // var selectedEntryDate1 = new Date(this.selectedEntryDate.year + '-' + this.selectedEntryDate.month + '-' + this.selectedEntryDate.day);
    // var selectedEntryDate2 = moment(selectedEntryDate1).format("YYYY-MM-DD");
    // this.travelSheetModel.entryDate = selectedEntryDate2;

    // var selectedFromDate1 = new Date(this.selectedFromDate.year + '-' + this.selectedFromDate.month + '-' + this.selectedFromDate.day);
    // var selectedFromDate2 = moment(selectedFromDate1).format("YYYY-MM-DD");
    // this.travelSheetModel.fromDate = selectedFromDate2;

    // var selectedToDate1 = new Date(this.selectedToDate.year + '-' + this.selectedToDate.month + '-' + this.selectedToDate.day);
    // var selectedToDate2 = moment(selectedToDate1).format("YYYY-MM-DD");
    // this.travelSheetModel.toDate = selectedToDate2;

    console.log('update click', this.travelSheetModel);

    this.travelSheetModel.entryDate = moment({
      year: this.selectedEntryDate.year,
      month: this.selectedEntryDate.month - 1, // Months are 0-based
      day: this.selectedEntryDate.day
    }).format("YYYY-MM-DD");
  
    this.travelSheetModel.fromDate = moment({
      year: this.selectedFromDate.year,
      month: this.selectedFromDate.month - 1,
      day: this.selectedFromDate.day
    }).format("YYYY-MM-DD");
  
    this.travelSheetModel.toDate = moment({
      year: this.selectedToDate.year,
      month: this.selectedToDate.month - 1,
      day: this.selectedToDate.day
    }).format("YYYY-MM-DD");
  
    console.log('Formatted Dates:', {
      entryDate: this.travelSheetModel.entryDate,
      fromDate: this.travelSheetModel.fromDate,
      toDate: this.travelSheetModel.toDate
    });
  

    console.log('hotel amount', this.travelSheetModel.approver);
    if ((this.travelSheetModel.approver != null) != null && this.travelSheetModel.client != null && this.travelSheetModel.assignment != null &&
      this.travelSheetModel.fy != null && this.travelSheetModel.entryDate != undefined &&
      this.travelSheetModel.fromDate != undefined && this.travelSheetModel.toDate != undefined) {
      if (this.travelSheetModel.trainAmount != 0 || this.travelSheetModel.airAmount != 0 || this.travelSheetModel.taxiAmount != 0 ||
        this.travelSheetModel.hotelAmount != 0 || this.travelSheetModel.toll != 0 || this.travelSheetModel.foodAmount != 0
        || this.travelSheetModel.otherAmount != 0 || this.travelSheetModel.carAmount != 0 || this.travelSheetModel.mobileAmount != 0 ||
        this.travelSheetModel.internetAmount != 0 || this.travelSheetModel.icaiMembershipFee != 0 ||
        this.travelSheetModel.microsoft365Subscription != 0 || this.travelSheetModel.seminarFee != 0) {
        console.log('doctype', this.docType);
        if (this.docType.length > 0 || this.travelSheetModel.carAmount != 0 || this.travelSheetModel.fareDocuments.length > 0 || this.travelSheetModel.toll != 0) {
          var validDocumentTypeValue: boolean;
          if (this.travelSheetModel.trainAmount != 0 && this.travelSheetModel.trainAmount != null) {
            console.log('this.tarinamout', this.travelSheetModel.trainAmount);
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "train");
            var validDocument = this.validateDocumentType(this.docType, "train");
            console.log('train validDocument', validDocument);
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Train Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.airAmount != 0 && this.travelSheetModel.airAmount != null) {
            console.log('this.tarinamout', this.travelSheetModel.trainAmount);
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "air");
            var validDocument = this.validateDocumentType(this.docType, "air");
            console.log('air validDocument', validDocument);

            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Air Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.taxiAmount != 0 && this.travelSheetModel.taxiAmount != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "taxi");
            var validDocument = this.validateDocumentType(this.docType, "taxi");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Taxi Document')
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.hotelAmount != 0 && this.travelSheetModel.hotelAmount != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "hotelStay");
            var validDocument = this.validateDocumentType(this.docType, "hotelStay");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Hotel Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.foodAmount != 0 && this.travelSheetModel.foodAmount != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "foodExpense");
            var validDocument = this.validateDocumentType(this.docType, "foodExpense");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Food Expense Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.mobileAmount != 0 && this.travelSheetModel.mobileAmount != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "mobile");
            var validDocument = this.validateDocumentType(this.docType, "mobile");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add mobile Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.internetAmount != 0 && this.travelSheetModel.internetAmount != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "internet");
            var validDocument = this.validateDocumentType(this.docType, "internet");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add internet Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.icaiMembershipFee != 0 && this.travelSheetModel.icaiMembershipFee != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "icaiMembershipFee");
            var validDocument = this.validateDocumentType(this.docType, "icaiMembershipFee");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add icaiMembershipFee Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.microsoft365Subscription != 0 && this.travelSheetModel.microsoft365Subscription != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "microsoft365Subscription");
            var validDocument = this.validateDocumentType(this.docType, "microsoft365Subscription");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add microsoft365Subscription Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.seminarFee != 0 && this.travelSheetModel.seminarFee != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "seminarFee");
            var validDocument = this.validateDocumentType(this.docType, "seminarFee");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add seminarFee Document');
              validDocumentTypeValue = true;
            }
          }
          if (this.travelSheetModel.otherAmount != 0 && this.travelSheetModel.otherAmount != null) {
            var validDocumentCheck = this.validateDocumentTypeCheck(this.travelSheetModel.fareDocuments, "others");
            var validDocument = this.validateDocumentType(this.docType, "others");
            if (!validDocument && !validDocumentCheck) {
              this.commonMessageService.swalAlertWithoutIcon('','Need to add Others Document');
              validDocumentTypeValue = true;
            } else {
              if ((this.travelSheetModel.otherAmount != 0) && this.travelSheetModel.natureOfExpense == undefined) {
                this.commonMessageService.swalAlertWithoutIcon('','Need to add Nature of Expense');
                validDocumentTypeValue = true;
              } else if (this.travelSheetModel.otherAmount > 10000) {
                this.commonMessageService.swalAlertWithoutIcon('','Other Amount should not be greater than 10000.');
                validDocumentTypeValue = true;
              }
            }
          }
          if (!validDocumentTypeValue) {
            console.log('inside if....');
            this.travelSheetModel.user = this.userModel;
            const data = new Blob([JSON.stringify(this.travelSheetModel)], {
              type: 'application/json'
            })
            const formData = new FormData();
            for (var i = 0; i < this.myFiles.length; i++) {
              formData.append('files', this.myFiles[i]);
            }
            formData.append('travelSheetRequestModel', data);

            this.travelSheetService.updateTravelSheetDetails(formData, this.docType).subscribe((resp: any) => {
              this.commonMessageService.updateMessage();
              this.closeModal();
            });
          }
        } else {
          this.commonMessageService.swalAlertWithoutIcon('','Attach Document');
        }
      } else {
        this.commonMessageService.swalAlertWithoutIcon('','Atleast Enter One Travelling Amount');
      }
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Fill All Mandatory Fields....!');
    }
  }

  onViewClick(travelsheet, modalContent) {
    console.log('travel sheet details', travelsheet);
    this.travelSheetModel = { ...travelsheet };
    this.openModal(modalContent);
  }
}
